import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor } from '../../../utils/styles-constants';
import { StoreState } from '../../../reducers';
import { StyledDownloadGroupButton } from './styles';
import { downloadAll, downloadImportantAssets } from '../../../containers/DownloadManager/actions';
import { ActionButton } from '../../../utils/driveItem';
import Loader, { LoaderType, LoaderStepName, DownloadingAllStep } from '../../Loader';
import { resetSelectedDownloadItems } from '../../../containers/DownloadManager/actions/store';

export interface DownloadGroupButtonProps {
	dispatch: Dispatch<StoreState>;
	action?: ActionButton;
	status: DownloadGroupButtonStatus;
	strongColor: string;
	isOnlyImportants?: boolean;
	isDownloading: boolean;
	isDeletingAll: boolean;
	loaderStep: DownloadingAllStep | undefined;
}

export enum DownloadGroupButtonStatus {
	Download = 'download_all',
	ContinueDownloading = 'continue_downloading',
	DownloadComplete = 'download_complete',
	Update = 'update_all',
}

const DownloadGroupButton = ({
	isOnlyImportants,
	isDownloading,
	loaderStep,
	action,
	status,
	isDeletingAll,
	strongColor,
	dispatch,
}: DownloadGroupButtonProps) => {
	if (isDeletingAll) {
		return null;
	}

	const handleClick = () => {
		if (isOnlyImportants) {
			dispatch(downloadImportantAssets());
			return;
		}
		dispatch(resetSelectedDownloadItems());
		dispatch(downloadAll());
	};

	const renderButtonContent = () => {
		if (isDownloading) {
			return (
				<Loader
					loaderStep={loaderStep ? loaderStep : { step: LoaderStepName.Downloading }}
					type={LoaderType.Button}
				/>
			);
		}

		return <Translate value={`messages.${status}${isOnlyImportants ? '_important' : ''}`} />;
	};

	const isDownloadCompleted = status === DownloadGroupButtonStatus.DownloadComplete;
	return (
		<StyledDownloadGroupButton
			onClick={!isDownloadCompleted && handleClick}
			color={isDownloadCompleted ? NewStyleColor.Green : strongColor}
			action={action}
		>
			{renderButtonContent()}
		</StyledDownloadGroupButton>
	);
};

export default DownloadGroupButton;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DownloadGroupButton/index.tsx